import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Task from '../Components/Maintenance/task';
import TaskReminder from '../Components/Maintenance/task-reminder';
import Settings from '../Components/Maintenance/settings';

export class ProjectAddEditMaintenanceSchedule extends Component {
    static propTypes = {
      projectId: PropTypes.string
    };

    constructor(props) {
      super(props);

      this.state = {
        tabs: {
          headers: [
            {name: 'Maintenance Tasks' },
            {name: 'Schedule' },
            {name: 'Settings' }
          ],
          contents: [
            (<Task projectId={this.props.projectId} />),
            (<TaskReminder projectId={this.props.projectId} />),
            (<Settings projectId={this.props.projectId} />)
          ]
        },
        activeIndex: 0
      };
    }

    renderTabHeaders = () => {
      return (
        <div className='maintenance-schedule-tab-header'>
          {
            this.state.tabs.headers.map((value, index) => {
              return (
                <button
                  key={index}
                  onClick={() => this.setState({activeIndex: index})}
                  className={this.state.activeIndex === index
                    ? 'radius-button-maintenance btn bn-primary btn-siteone'
                    : 'radius-button-maintenance btn btn-siteone-default'}>
                  {value.name}
                </button>
              );
            })
          }
        </div>
      );
    }

    renderTabContent = () => {
      return (this.state.tabs.contents[this.state.activeIndex]);
    }

    render() {
      return (
        <div className='maintenance-schedule-wrapper'>
          {this.renderTabHeaders()}
          {this.renderTabContent()}
        </div>
      );
    }
}

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps)(ProjectAddEditMaintenanceSchedule);



// WEBPACK FOOTER //
// ./src/Projects/Containers/project-add-edit-maintenance-schedule.js